/**
 * MorpheusAppShellPlaceholder
 *
 * Loading placeholder shown in the content region while a lazy route chunk is
 * fetched (Suspense fallback). Replaces the inline hard-coded-px spinner that
 * was flagged in review — visual values come from Morpheus `$utk-*` tokens.
 */
import React from 'react'
import classnames from 'classnames/bind'
import styles from './shell.scss'

const cx = classnames.bind(styles)

export const MorpheusAppShellPlaceholder: React.FC = () => (
  <div className={cx('shell-placeholder')} aria-busy='true' aria-live='polite'>
    <div className={cx('shell-spinner')} />
    <span className={cx('shell-sr-only')}>Loading…</span>
  </div>
)

export default MorpheusAppShellPlaceholder
